export const ALL_COMMITS_TEXT = 'All commits'

/**
 * Generates button text for commit selection based on current selection state
 */
export function getButtonTextFromCommitData({
  endOid,
  startOid,
  firstCommitInRange,
}: {
  endOid?: string | null
  startOid?: string | null
  firstCommitInRange?: string | null
}) {
  // treat a range that only includes one commit like a single commit
  if (firstCommitInRange && endOid && firstCommitInRange === endOid) {
    return `Commit ${endOid.slice(0, 7)}`
  }

  if (startOid && endOid) {
    return `${startOid.slice(0, 7)}..${endOid.slice(0, 7)}`
  }

  return ALL_COMMITS_TEXT
}
